/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { colors, borderRadius, typography } from '../../styles/theme';

const sectionStyles = css`
  background: ${colors.background.tertiary};
  max-width: 100%;
  padding: 4rem 1rem;

  @media (min-width: 768px) {
    padding: 4rem 2rem;
  }
`;

const containerStyles = css`
  max-width: 1200px;
  margin: 0 auto;
`;

const sectionHeaderStyles = css`
  text-align: center;
  margin-bottom: 3rem;

  h2 {
    font-family: ${typography.fontFamily.heading};
    font-size: ${typography.fontSize['2xl']};
    color: ${colors.text.primary};
    margin-bottom: 0.75rem;

    @media (min-width: 768px) {
      font-size: ${typography.fontSize['3xl']};
    }
  }

  p {
    color: ${colors.text.secondary};
    max-width: 600px;
    margin: 0 auto;
  }
`;

const stepsGridStyles = css`
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const stepCardStyles = css`
  text-align: center;
  position: relative;

  .step-number {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, ${colors.primary[600]}, ${colors.primary[700]});
    color: white;
    border-radius: ${borderRadius.full};
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${typography.fontFamily.heading};
    font-size: ${typography.fontSize['2xl']};
    font-weight: ${typography.fontWeight.bold};
    margin: 0 auto 1rem;
    box-shadow: 0 4px 12px ${colors.primary[500]}40;
  }

  h4 {
    font-family: ${typography.fontFamily.heading};
    font-size: ${typography.fontSize.lg};
    font-weight: ${typography.fontWeight.bold};
    color: ${colors.text.primary};
    margin-bottom: 0.5rem;
  }

  p {
    color: ${colors.text.secondary};
    font-size: ${typography.fontSize.sm};
  }

  @media (min-width: 768px) {
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      top: 30px;
      right: -1rem;
      width: calc(100% - 60px);
      height: 2px;
      background: ${colors.neutral[200]};
      transform: translateX(50%);
    }
  }
`;

const stepsData = [
  { number: 1, title: 'Arayın', description: 'Bizi arayın veya uygulamadan talep oluşturun' },
  { number: 2, title: 'Konum Paylaşın', description: 'Bulunduğunuz konumu bizimle paylaşın' },
  { number: 3, title: 'Bekleyin', description: 'En yakın sürücümüz hemen yola çıksın' },
  { number: 4, title: 'Çözüm', description: 'Profesyonel ekibimiz sorununuzu çözsün' },
];

export default function HowItWorksSection() {
  return (
    <section css={sectionStyles}>
      <div css={containerStyles}>
        <div css={sectionHeaderStyles}>
          <h2>Nasıl Çalışır?</h2>
          <p>4 kolay adımda yardım alın</p>
        </div>
        <div css={stepsGridStyles}>
          {stepsData.map(step => (
            <div key={step.number} css={stepCardStyles}>
              <div className="step-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
